module.exports = __webpack_public_path__ + "img/arrow-back-white.6fc381d2.svg";